<template>
  <div>
  <el-card  class="box-card">
    <div slot="header" class="clearfix">
      <span style="font-size: 16px;">选择计划：</span>
      <el-select v-model="value" placeholder="请选择">
        <el-option>桩基工程施工</el-option>
        <el-option>建房进度计划</el-option>
      </el-select>
      <el-button class="but-prople">导出报表</el-button>
    </div>
      <div class="card-top">
        <span style="color: deepskyblue">{$项目名称}</span>
        <span style="color: deepskyblue">{$计划名称}</span>
        <span>施工进度表</span>
      </div>
      <!-- 表格部分 -->
      <table border="1" cellspacing="0" width="100%" height="380">
        <tr> 
          <th colspan="2">整体进度：</th>
          <th colspan="6">重要程度：</th>
          <th colspan="3">总负责人：</th>
          <th colspan="3">报表日期：</th>
        </tr>
        <tr> 
          <td>序号</td> 
          <td colspa="4">任务名称</td>
          <td>当前状态</td>
          <td>延期天数</td>
          <td>完成进度</td>
          <td>计划工期天数</td>
          <td>计划占比</td>
          <td>计划开始</td>
          <td>计划结束</td>
          <td>实际工期天数</td>
          <td>实际开始</td>
          <td>实际完成</td>
          <td>责任人</td>
          <td>相关人</td>
        </tr>
        <tr v-for="item in 3">
          <td v-for="item in 14"></td>
        </tr>
        <tr>
          <td rowspan="2">备注:</td>
        </tr>
      </table>
    </el-card>
    <!-- 模型部分 -->
    <div style="padding:-30px">
      <iframe
        :src="src"
        width="100%"
        :height="ModelHeight"
        frameborder="0"
      ></iframe>
    </div>
</div>
</template>

<script>
export default{
  data(){
    return{
      src: window.location.origin + "/#/trueProgressModel",
      ModelHeight: document.body.clientHeight - 90
    }
  }
}
</script>

<style lang="less" scoped>
.box-card{
  margin-bottom: 20px;
  .but-prople{
    margin-left: 40px;
    background-color: #6084fd;
    color: white;
  }
  .card-top{
    text-align: center;
    font-size: 22px;
    font-weight: bold;
  }
  td{
    text-align: center;
    font-weight: bold;
  }
  th{
    padding-left: 25px;
  }
}
</style>